export const SHOW_LMT_IFRAME = true;
export const SHOW_CRICKET_SCORE_IFRAME = true;
export const NANO_TV_URL = "https://stream.com";
export const FLASH_TV_URL = "https://tv.com";